import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { memo, useEffect, useState } from "react";
import IEvent from "../../../types/Event";
import IActividad from "../../../types/Actividad";
import AgendaService from "../../../services/AgendaService";
import ClaseUtils from "../../../utils/Clase";
import IAlert from "../../../types/Alert";
import { useNavigate } from "react-router-dom";
import LogService from "../../../services/LogService";
import ILog from "../../../types/Log";
import * as constantes from "../../../common/Constantes";


interface CommentDialogProps {
  open: boolean;
  initialComment: string;
  event: IEvent | undefined;
  actividades: IActividad[];
  onCancel: () => void;
  updateEvents: (updatedEvents: any[], eventId?: string | number | null) => void;
  setAlert: (alert: IAlert) => void;
}

const CommentDialogComponent = ({ open, initialComment, event, actividades, onCancel, updateEvents, setAlert }: CommentDialogProps) => {
    
    const history = useNavigate();
    const [localComment, setLocalComment] = useState(initialComment);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      if (open) setLocalComment(initialComment);
    }, [initialComment, open]);
  
    const handleSave = () => {
      if(localComment.trim() === '') {
          setAlert({ open: true, severity: 'warning', msg: 'No hay comentarios que guardar' });
          return;
        }
        if(!event?.id) return;
    
        setLoading(true);
        const update = { comentarios: localComment };
    
        AgendaService.addComentarioClass(event.id.toString(), update)
          .then((response: any) => {
            const updatedEvent = ClaseUtils.formatClasses([response.data], actividades);
            updateEvents(updatedEvent, event.id);
            setAlert({ open: true, severity: 'success', msg: 'Comentarios añadidos correctamente' });
          })
          .catch((e: any) => {
              if (e.response.status === 401) {
                  localStorage.clear();
                  history(constantes.R_HOME);
              } else {
                  const error: ILog = { method: 'CommentDialog.Component.addComentarios', level: 'error', message: e.message, meta: e.response };
                  LogService.logError(error);
                  setAlert({ open: true, severity: 'error', msg: e.response.data.message });
              }
          })
          .finally(() => {
            setLoading(false);
            onCancel();
          });
    };

    return (
        <Dialog open={open} maxWidth="lg" onClose={onCancel}>
            <DialogTitle>Añadir comentarios a la clase</DialogTitle>
            <DialogContent>
                <TextField multiline rows="3" value={localComment} variant="outlined" label="Comentarios" margin="dense" fullWidth autoFocus onChange={(e) => setLocalComment(e.target.value)} />
            </DialogContent>
            {loading ?
                <Grid container>
                    <CircularProgress style={{ margin: '20px auto' }} />
                </Grid> :
                <DialogActions>
                    <Button onClick={handleSave}>Guardar</Button>
                    <Button onClick={onCancel}>Cancelar</Button>
                </DialogActions>
            }
        </Dialog>
  );
};

export const CommentDialog = memo(CommentDialogComponent);
export default CommentDialog;